import { twMerge } from 'tailwind-merge'

export default function SeisBadge({ title, className = '' }) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-center bg-[#3538cd] bg-opacity-[.23] rounded-full py-0.5 px-3 text-xs font-medium text-[#3538CD]',
        className,
      )}
    >
      {title}
    </div>
  )
}
